<template>
    <div class="OrderAndBuy fSize">
        <van-notice-bar left-icon="info-o" wrapable :scrollable="false">
            购买数量最小1，用户默认选择
        </van-notice-bar>
        <van-cell-group>
            <van-cell>
                <van-row>
                    <van-col span="8">套餐单价</van-col>
                    <van-col span="16">{{'￥'+(data.price/100)}}</van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="8">购买数量</van-col>
                    <van-col span="16">
                        <van-stepper :disabled="!orderCreateStatus" v-model="data.count" min="1" integer
                                     @change="onChange"/>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="8">订单金额</van-col>
                    <van-col span="16">{{'￥'+(data.amount/100)}}</van-col>
                </van-row>
            </van-cell>
            <!--<van-cell>
                <van-row>
                    <van-col span="8">用户选择</van-col>
                    <van-col span="16">
                        <van-checkbox-group v-model="data.personal" direction="horizontal">
                            <van-checkbox v-for="item in userData" :name="item.id" shape="square" disabled>
                                {{item.name}}
                            </van-checkbox>
                        </van-checkbox-group>
                    </van-col>
                </van-row>
            </van-cell>-->
            <van-cell v-show="!orderCreateStatus">
                <van-row>
                    <van-col span="8">订单编号</van-col>
                    <van-col span="16">{{data.buyOrderCode}}</van-col>
                </van-row>
            </van-cell>
        </van-cell-group>
        <van-cell class="buttonFixed" safe-area-inset-bottom>
            <van-button v-show="orderCreateStatus" size="normal" round block type="default" :loading="ordering"
                        loading-text="创建中..." @click="submitOrder">提交订单
            </van-button>
            <van-button v-show="!orderCreateStatus" size="normal" round block type="info" :loading="paying"
                        loading-text="支付中..." @click="submitPay"> 去支付
            </van-button>
        </van-cell>
    </div>
</template>
<script>
    import {
        Dialog, Field, Cell, CellGroup, Stepper, Checkbox, CheckboxGroup, Button, NoticeBar, Toast, Col, Row
    } from 'vant';
    import {getUser} from '@/api/user';
    import {createOrder, payOrder} from '@/api/order';

    export default {
        name: "OrderAndBuy",
        props: {
            item: {type: String, default: ""}
        },
        components: {
            [Dialog.name]: Dialog, [Cell.name]: Cell, [CellGroup.name]: CellGroup, [Field.name]: Field,
            [Stepper.name]: Stepper, [Checkbox.name]: Checkbox, [CheckboxGroup.name]: CheckboxGroup,
            [Button.name]: Button, [NoticeBar.name]: NoticeBar, [Toast.name]: Toast, [Col.name]: Col,
            [Row.name]: Row
        },
        data() {
            return {
                orderCreateStatus: true,
                userData: [],
                data: [],
                //按钮样式
                ordering: false,
                paying: false
            }
        },
        watch: {
            //正确给 cData 赋值的 方法
            item: function (newVal, oldVal) {
                newVal && this.drawChart(newVal); //newVal存在的话执行drawChar函数
            }
        },
        created() {
            const that = this;
            that.drawChart(that.item);
        },
        methods: {
            //数据处理
            drawChart(newVal) {
                const that = this;
                //按钮初始化//that.orderCreateStatus = true;
                that.ordering = false;
                that.paying = false;
                let data = JSON.parse(newVal);
                if (!data.buyOrderCode) {
                    data.personal = [];                             //初始化用户
                    data.count = 1;                                 //购买数量
                    data.amount = data.count * data.price;          //购买数量
                }
                that.orderCreateStatus = !data.buyOrderCode;
                that.data = data;
                //获取用户信息
                that.gainUser();
            },
            //数量变更
            onChange(e) {
                const that = this;
                that.data.amount = e * that.data.price;
            },
            //获取用户信息
            gainUser() {
                const that = this;
                if (sessionStorage.getItem("userIsBang") === 'yes') {
                    getUser({openId: sessionStorage.getItem("openid")}).then(resp => {
                        that.userData = resp.code === 200 ? resp.data : [];
                        //默认选择当前所有绑定账户
                        let newArray = [];
                        for (let i = 0; i < that.userData.length; i++) {
                            newArray.push(that.userData[i].id);
                        }
                        that.data.personal = newArray;
                    }).catch(err => {
                        console.log(err);
                    })
                } else {
                    //如果用户信息为空则去设置用户
                    Dialog.alert({
                        message: '用户信息为空无法进行下一步操作，去添加',
                    }).then(() => {
                        that.$router.push({path: "/userAdd"})
                    });
                    return false
                }
            },
            //订单确认
            submitOrder() {
                const that = this;
                that.ordering = true;
                //组装订单所需的数据
                let data = JSON.parse(JSON.stringify(that.data));
                let obj = {
                    productId: data.id,
                    productPrice: data.price,
                    //productCode: data.code,
                    userId: data.personal.join(","),
                    buyNum: data.count,
                    buyPrice: data.price,
                    buyMoney: data.amount,
                    openId: sessionStorage.getItem('openid')
                }
                createOrder(obj).then(resp => {
                    that.ordering = false;
                    if (resp.code === 200) {//创建订单成功
                        that.data.buyOrderCode = resp.data.buyOrderCode;
                        that.orderCreateStatus = false;
                    } else {//订单创建失败
                        Toast.fail('订单创建失败');
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            //订单支付
            submitPay() {
                const that = this;
                if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                    }
                }
                that.paying = true;
                //取ip
                let ip = JSON.parse(localStorage.getItem("localCs"));
                //payOrder
                console.log(that.data);
                let obj = {
                    //组装支付参数
                    o: sessionStorage.getItem("openid"),
                    n: that.data.count,
                    p: that.data.amount,
                    c: that.data.id,
                    b: that.data.buyOrderCode,
                    ip: ip.cip
                };
                payOrder(obj).then(resp => {
                    that.paying = false;
                    if (resp.code === 200) {//订单支付成功
                        let data = resp.data;
                        //调起微信公众号支付
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', {
                                "appId": data.appId,            //公众号名称，由商户传入
                                "timeStamp": data.timeStamp,    //时间戳，自1970年以来的秒数
                                "nonceStr": data.nonceStr,      //随机串
                                "package": data.package,
                                "signType": data.signType,      //微信签名方式：
                                "paySign": data.paySign         //微信签名
                            },
                            function (res) {
                                if (res.err_msg === "get_brand_wcpay_request:ok") {
                                    //成功后
                                    that.paying = false;
                                    Dialog.alert({
                                        message: '支付成功,关闭页面！',
                                    }).then(() => {
                                        that.data = {};
                                        //关闭购买框
                                        that.$emit('fatherMethod');
                                    });
                                } else {
                                    Toast("支付失败，继续支付！");
                                }
                            }
                        );
                    } else {//订单创建失败
                        Toast.fail('订单支付失败');
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>
<style scoped>
    .OrderAndBuy {
        min-height: 6rem;
    }
</style>
